import optionsApi from "./optionsApi";
import {
  AvailableTableFilters,
  SaveTableState,
  TableName,
} from "../types/Table";

export async function getReportPresets(
  tableName: TableName
): Promise<AvailableTableFilters[]> {
  return optionsApi
    .get(`/v1/filterState/getAll?tableName=${tableName}`)
    .then((res) => res.data.data);
}

export async function saveReportPreset(payload: SaveTableState): Promise<void> {
  return optionsApi
    .post("/v1/filterState/save", payload)
    .then((res) => res.data.data);
}

export async function deleteReportPreset(id: string): Promise<void> {
  return optionsApi
    .delete(`/v1/filterState/delete?id=${id}`)
    .then((res) => res.data.data);
}
